import React from "react";
import { FiMail } from "react-icons/fi";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  const currentYear = new Date().getFullYear();
  const contact = siteConfig.contact || {};
  const categories = siteConfig.categories || [];
  const primaryCategories = categories.slice(
    0,
    Math.ceil(categories.length / 2)
  );
  const secondaryCategories = categories.slice(
    Math.ceil(categories.length / 2)
  );
  const collectionLinks = (siteConfig.navigation || []).filter((item) =>
    ["new", "bestsellers"].includes(item.id)
  );
  const discoverLinks = (siteConfig.navigation || []).filter((item) =>
    ["home", "about", "contact"].includes(item.id)
  );
  const footerColumns = [
    {
      id: "shop",
      title: "Shop the pantry",
      links: primaryCategories,
    },
    {
      id: "more-pantry",
      title: "More for the table",
      links: [
        ...secondaryCategories,
        { id: "all-products", name: "Shop all products", path: "/shop" },
      ],
    },
    {
      id: "discover",
      title: "Discover",
      links: [
        ...collectionLinks,
        ...discoverLinks,
        ...(siteConfig.editorialNavigation || []),
      ],
    },
    {
      id: "care",
      title: "Customer care",
      links: siteConfig.customerCareNavigation || [],
    },
    {
      id: "policies",
      title: "Legal & policies",
      links: siteConfig.legalNavigation || [],
    },
  ];

  const handleInternalLink = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const address = contact.address || siteConfig.address?.formatted;

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-body">
        <div className="footer-shell footer-body__inner">
          <div className="footer-brand">
            <Link
              className="footer-brand__name"
              to="/"
              onClick={handleInternalLink}
            >
              {siteConfig.logo?.value ||
                siteConfig.logoText ||
                siteConfig.brandName}
            </Link>
            <p>{siteConfig.description}</p>
            <address>
              {address && <span>{address}</span>}
              {contact.email && (
                <a href={`mailto:${contact.email}`}>
                  <FiMail aria-hidden="true" /> {contact.email}
                </a>
              )}
            </address>
          </div>

          <nav className="footer-links" aria-label="Footer navigation">
            {footerColumns.map((column) => (
              <div className="footer-links__column" key={column.id}>
                <h2>{column.title}</h2>
                <ul>
                  {column.links.map((item) => (
                    <li key={item.id}>
                      <Link to={item.path} onClick={handleInternalLink}>
                        {item.label || item.shortName || item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>
        </div>

        <div className="footer-shell footer-bottom">
          <p>
            © {currentYear} {siteConfig.brandName}. All rights reserved.
          </p>
          <p className="footer-bottom__note">
            <span>Secure payments:</span> Visa · Mastercard · American Express ·
            JCB
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
